import { SuperAdminModal } from '../../../baseComponents';
import { useSelector } from 'react-redux';
import JsonView from '@uiw/react-json-view';

const FormConditionModal = ({ isOpen, setIsOpen }) => {
  const { getFormCondition } = useSelector(
    (state) => state?.formConditionsState
  );

  const table_content = getFormCondition?.table_content;
  const video_content = getFormCondition;

  const sections = [
    {
      heading: <div className="mb-3">Form content</div>,
      fields: [
        {
          name: 'sections',
          type: 'label',
          title: (
            <div className="bg-white p-3 rounded-xl h-[400px]">
              <div className="h-[380px] overflow-y-auto">
                <JsonView
                  value={table_content ? table_content : video_content}
                  style={{ fontSize: '1rem' }}
                />
              </div>
            </div>
          ),
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      className={'feedback-modal'}
      closable={true}
      centered={true}
      submitButtonText=""
      cancelButtonText=""
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={() => {}}
    />
  );
};

export default FormConditionModal;
